/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsissuename2Inputs */

const en_ticketsissuename2 = /** @type {(inputs: Ticketsissuename2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give the ticket type a name.`)
};

const de_ticketsissuename2 = /** @type {(inputs: Ticketsissuename2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib der Ticketart einen Namen.`)
};

/**
* | output |
* | --- |
* | "Give the ticket type a name." |
*
* @param {Ticketsissuename2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsissuename2 = /** @type {((inputs?: Ticketsissuename2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsissuename2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsissuename2(inputs)
	return de_ticketsissuename2(inputs)
});
export { ticketsissuename2 as "ticketsIssueName" }